import React, { useEffect } from 'react'
import {
  AggReport as AggReportComponent,
  CLIENT_TYPE,
  searchBarFocusState,
} from '@landscape/ui-lib'
import { useSetRecoilState } from 'recoil'
import { InstitutionInfo } from 'components/etc/InstitutionInfo'

export const AggReport = () => {
  const adminType = CLIENT_TYPE.EXTERNAL
  const setSearchBarFocus = useSetRecoilState(searchBarFocusState)
  useEffect(() => setSearchBarFocus(false), [setSearchBarFocus])

  return (
    <>
      <InstitutionInfo />
      <AggReportComponent adminType={adminType} />
    </>
  )
}
